angular.module('gym.reports').controller('ConfirmBulkMobileAppChangesCtrl', ["$scope", "MobileApp", "Templates", "TemplateSanitizeService", "$modalInstance", "flash", "contactsCount", "contactIds", "action", "filters", "mobileAppMeta", "allPagesSelected", function($scope, MobileApp, Templates, TemplateSanitizeService, $modalInstance, flash, contactsCount, contactIds, action, filters, mobileAppMeta, allPagesSelected) {
  var params;
  if (action === 'send_invite_email' || action === 'send_invite_sms') {
    params = {
      count: 1,
      'filters[role]': 'mobile_app_invite_prompt',
      'filters[channel]': action === 'send_invite_email' ? 'email' : 'sms'
    };
    Templates.getList(params).then(function(templates) {
      return $scope.template = templates[0];
    });
  }
  $scope.contactsCount = contactsCount;
  $scope.action = action;
  $scope.mobileAppMeta = mobileAppMeta;
  $scope.params = {
    action: action,
    contact_ids: contactIds,
    recipient_email: window.currentUser.email,
    features: []
  };
  $scope.features = {};
  $scope.onFeatureToggle = function(feature) {
    return $scope.params.features = $scope.features[feature] ? $scope.params.features.concat(feature) : _.without($scope.params.features, feature);
  };
  $scope.submit = function() {
    var data;
    $scope.isLoading = true;
    $scope.errors = {};
    if (action === 'send_invite_email') {
      data = TemplateSanitizeService.sanitize($scope.template);
      $scope.params.invite_email_subject = data.subject;
      $scope.params.invite_email_content = data.content;
    }
    if (action === 'send_invite_sms') {
      data = TemplateSanitizeService.sanitize($scope.template);
      $scope.params.invite_sms_content = data.content;
    }
    data = {
      withoutNamespace: true,
      bulk_mobile_app_operation: $scope.params
    };
    if (allPagesSelected) {
      data.select_all_pages = 1;
      data.filters = filters;
    }
    return MobileApp.all('bulk_contact_changes').doPOST(data, 'perform').then(function() {
      return $modalInstance.close();
    }, function(response) {
      var ref;
      flash.error = response.data.error || 'Something went wrong, please try again later';
      $scope.errors = (ref = response.data.bulk_mobile_app_operation) != null ? ref.errors : void 0;
      return $scope.isLoading = false;
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
